'use strict'

import React from 'react'
import classnames from 'classnames'

import './Switch.less'

/**
 * A constant, default class for every SwitchOption
 * @constant
 * @private
 */
const COMPONENT_OPTION_CLASS = 'nmc-switch-option'

/**
 * @class Switch
 */
class SwitchOption extends React.Component {
  /**
   * @constructor
   * @param {Object} props - properties for component
   */
  constructor (props) {
    super(props)
    this.onSelect = this.onSelect.bind(this)
  }

  /**
   *
   */
  onSelect (e) {
    const id = this.props['data-id']
    this.props.onSelect(id)
  }

  /**
   * Render
   */
  render () {
    const {isSelected, className, ...props} = this.props
    const classNames = classnames(COMPONENT_OPTION_CLASS, {
      selected: isSelected
    }, className)
    return (
      <button className={classNames} {...props} onClick={this.onSelect}>{this.props.children}</button>
    )
  }
}

SwitchOption.COMPONENT_OPTION_CLASS = COMPONENT_OPTION_CLASS

export default SwitchOption



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Switch/SwitchOption.js